<template>
<div>
    <button class="btn btn-primary m-md" @click="show" v-if="conversacion">Ver Conversacion</button>

    <div>
        <div class="modal fade" role="dialog" id="Modal">
            <div class="modal-dialog modal-lg">
                <div class="modal-content">
                    <div class="modal-header">
                        <h4 class="modal-title">Conversacion </h4>
                    </div>
                    <div class="modal-body">
                        <div class="row">
                            <div class="col-md-12">
                                <div class="ibox" style="    overflow: scroll;">
                                    <div v-for="(item, index) in conversacion.detalles" :key="index">
                                        <div :class="'conver '+ revisa_direccion(item) "> {{muestra_mensaje(item)}}
                                            <div style="font-size: 11px;">
                                                {{item.created_at}}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
</template>

<script>
export default {
    props: ['uniqueid'],
    data() {
        return {
            conversacion: null,

        }
    },
    mounted() {
        axios.get('verInfo/whatsapp').then(response => {
            this.conversacion = response.data;
            console.log(this.conversacion);
        }).catch(error => {
            console.log(error);
        })
    },
    methods: {
        revisa_direccion(mensaje) {
            if (this.conversacion.direccion_mensaje == "Entrada" && this.conversacion.emisor != mensaje.emisor) {
                return "right"
            }

            if (this.conversacion.direccion_mensaje == "Salida" && this.conversacion.emisor != mensaje.emisor) {
                return "right"
            }
        },
        muestra_mensaje(mensaje) {
            if (this.conversacion.direccion_mensaje == "Entrada") {
                if (this.conversacion.emisor != mensaje.emisor)
                    return this.conversacion.receptor +": "+ mensaje.mensaje
                else
                    return this.conversacion.emisor +": "+ mensaje.mensaje
            }else{
                if (this.conversacion.emisor != mensaje.emisor)
                    return this.conversacion.emisor +": "+ mensaje.mensaje
                else
                    return this.conversacion.receptor +": "+ mensaje.mensaje
            }
        },
        show() {
            $('#Modal').modal('show')

        },
        hide() {
            console.log("entre");
            this.dt.datos = [];
            $('#Modal').modal('hide')
        },
    },
}
</script>

<style>
.conver {
    border: 1px solid;
    border-radius: 8px;
    padding: 5px;
}

.right {
    text-align: right;
    background: rgb(147 235 169);
}
</style>
